import React from 'react';
import createSlug from '../utils/createSlug';
import { Link } from 'gatsby';
import Img from 'gatsby-image';

import * as S from '../components/styles.css';
import ConcatWords from '../utils/ConcatWords';
import formatDate from '../utils/formatDate';
import { stripOuterTags } from '../utils/stripHtml';

const renderList = ({ node }) => {
  const image = node.image?.localFile.childImageSharp.fluid;
  const slug = '/' + createSlug(node.title) + '/';

  return (
    <S.Article>
      {image && (
        <S.ImageWrapper>
          <S.Image>
            <Link to={slug}>
              <Img fluid={image} alt={node.title} />
            </Link>
          </S.Image>
        </S.ImageWrapper>
      )}

      <S.ArticleWrapper>
        <S.Author>
          Av <Link to={`/author/${createSlug(node.author.name)}/`}>{node.author.name}</Link>
        </S.Author>

        <Link to={slug}>
          <S.Title>{node.title}</S.Title>
        </Link>

        <S.DateText>{formatDate(node.date)}</S.DateText>

        <S.Category>
          {node.categories?.map((cat, index, arr) => (
            <ConcatWords arrCount={arr.length} index={index} key={cat}>
              <Link to={`/category/${createSlug(cat.title)}/`}>{cat.title}</Link>
            </ConcatWords>
          ))}
        </S.Category>

        <S.Description>
          <Link to={slug} dangerouslySetInnerHTML={{ __html: stripOuterTags(node.excerpt.childMarkdownRemark.html) }} />
        </S.Description>

        <S.ReadMore>
          <Link to={slug}>Läs mer &raquo;</Link>
        </S.ReadMore>
      </S.ArticleWrapper>
    </S.Article>
  );
};

export default renderList;
